<div class="modal-header">

    <h5 class="modal-title">
        Cadastrar Plano Recuperacao Judicial
    </h5>
    <button type="button" class="close" (click)="dismiss()">&times;</button>
</div>
<div class="modal-body">
    <div class="row" *ngIf="pagina == 1">
        <div class="col-12">
            <div class="borda card">
                <div class="form-group" style="width: 100%;">
                    <label class="form-label">Valor do crédito</label>
                    <input type="text" style="width: 150px;" currencyMask
                        [options]="{ prefix: '', thousands: '.', decimal: ',' }" class="form-control"
                        [(ngModel)]="planoRecuperacaoJudicial.valorCredito" (change)="recarregarValores()"
                        (blur)="recarregarValores()" />
                </div>
                <div class="form-group" style="width: 100%;">
                    <label class="form-label">Vinculação de Dívidas</label>
                    <br />
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="vinculacaoDeDivida" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.vinculacaoDeDivida" id="credito_nominal" value="0" />
                        <label class="form-check-label" for="credito_nominal">Crédito Nominal</label>
                    </div>
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="vinculacaoDeDivida" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.vinculacaoDeDivida" id="credito_vinculado" value="1" />
                        <label class="form-check-label" for="credito_vinculado">Crédito Vinculado</label>
                    </div>
                </div>
                <div class="form-group" style="width: 100%;">
                    <label class="form-label">Modalidade de Amortização</label>
                    <br />
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="modalidadeDeAmortizacao" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.modalidadeDeAmortizacao" id="mensal" value="0" (change)="selecionaModalidadeAmortizacao()" />
                        <label class="form-check-label" for="mensal">Mensal</label>
                    </div>
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="modalidadeDeAmortizacao" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.modalidadeDeAmortizacao" id="bimestral" value="1" (change)="selecionaModalidadeAmortizacao()" />
                        <label class="form-check-label" for="bimestral">Bimestral</label>
                    </div>
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="modalidadeDeAmortizacao" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.modalidadeDeAmortizacao" id="trimestral" value="2" (change)="selecionaModalidadeAmortizacao()" />
                        <label class="form-check-label" for="trimestral">Trimestral</label>
                    </div>
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="modalidadeDeAmortizacao" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.modalidadeDeAmortizacao" id="semestral" value="3" (change)="selecionaModalidadeAmortizacao()" />
                        <label class="form-check-label" for="semestral">Semestral</label>
                    </div>
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="modalidadeDeAmortizacao" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.modalidadeDeAmortizacao" id="anual" value="4" (change)="selecionaModalidadeAmortizacao()" />
                        <label class="form-check-label" for="anual">Anual</label>
                    </div>
                    <div class="form-check form-check-inline form-group mt-1">
                        <input mdbRadio name="modalidadeDeAmortizacao" class="form-check-input" type="radio"
                            [(ngModel)]="planoRecuperacaoJudicial.modalidadeDeAmortizacao" id="personalizada" value="5" (change)="selecionaModalidadeAmortizacao()" />
                        <label class="form-check-label" for="personalizada">Personalizada</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-3">
                        <div class="form-group" style="width: 100%;">
                            <div class="desagio-label">
                                <label class="form-label">Deságio</label>
                                <input type="range" class="desagio-range" [(ngModel)]="planoRecuperacaoJudicial.desagio" min="0"
                                    max="100" step="0.01" (change)="recarregarValores()" />
                            </div>
                            <input type="number" style="width: 150px;" min="0" max="100" step="0.01"
                                class="form-control" [(ngModel)]="planoRecuperacaoJudicial.desagio"
                                (change)="recarregarValores()" />
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group" style="width: 100%;">
                            <label class="form-label">Crédito com Deságio</label>
                            <input type="text" style="width: 150px;" currencyMask
                                [options]="{ prefix: '', thousands: '.', decimal: ',' }" class="form-control" disabled
                                [(ngModel)]="planoRecuperacaoJudicial.valorCreditoComDesagio" (change)="recarregarValores()" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <label class="form-label">Data do Pedido</label>
                        <br>
                        <p-calendar [(ngModel)]="planoRecuperacaoJudicial.dataPedido" dateFormat="dd/mm/yy" slotChar="dd/mm/yyyy"
                            [showIcon]="true" inputId="icon"></p-calendar>
                    </div>
                    <div class="col-4">
                        <label class="form-label">Data da Homologação</label>
                        <br>
                        <p-calendar [(ngModel)]="planoRecuperacaoJudicial.dataHomologacao" dateFormat="dd/mm/yy"
                            slotChar="dd/mm/yyyy" [showIcon]="true" inputId="icon"></p-calendar>
                    </div>
                    <div class="col-4">
                        <label class="form-label">Data Prevista Pagamento</label>
                        <br>
                        <p-calendar [(ngModel)]="planoRecuperacaoJudicial.dataPrevistaPagamento" dateFormat="dd/mm/yy"
                            slotChar="dd/mm/yyyy" [showIcon]="true" inputId="icon"></p-calendar>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label class="form-label">Carência</label>
                            <div class="carencia">
                                <input type="number" class="form-control"
                                    [(ngModel)]="planoRecuperacaoJudicial.prazoCarencia" />
                                <ng-select [items]="listTipoPeriodo" [(ngModel)]="planoRecuperacaoJudicial.prazoCarenciaTipo"
                                    [ngModelOptions]="{standalone: true}" bindLabel="nome" bindValue="id"
                                   >
                                </ng-select>
                            </div>
                        </div>                        
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label class="form-label">{{prazoPagamentoVencimentoLabel}}</label>
                            <div class="carencia">
                                <input type="number" class="form-control"
                                    [(ngModel)]="planoRecuperacaoJudicial.prazoPagamentoPagamento" />
                                <ng-select [items]="listTipoPeriodo" [(ngModel)]="planoRecuperacaoJudicial.prazoPagamentoPagamentoTipo"
                                    [ngModelOptions]="{standalone: true}" bindLabel="nome" bindValue="id">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label class="form-label">Classe do Crédito</label>
                            <ng-select [items]="listClasseCredito" [(ngModel)]="planoRecuperacaoJudicial.classeCredito"
                            [ngModelOptions]="{standalone: true}" bindLabel="nome" bindValue="id" [loading]="listClasseCredito.length == 0"
                            >
                        </ng-select>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label class="form-label">Abrange Garantidores/Coobrigados</label>
                            <ng-select [items]="listSimNao" [(ngModel)]="planoRecuperacaoJudicial.abrangeGarantidoresCoobrigados"
                            [ngModelOptions]="{standalone: true}" bindLabel="nome" bindValue="id"
                            >
                        </ng-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                       <label class="form-check-label" for="flexSwitchCheckChecked">Credor Fornecedor/Parceiro</label>
                       <mat-slide-toggle [(ngModel)]="planoRecuperacaoJudicial.possuiCredorFornecedorParceiro" [color]="primary"></mat-slide-toggle>                            
                       <textarea class="form-control" rows="3" *ngIf="planoRecuperacaoJudicial.possuiCredorFornecedorParceiro" [(ngModel)]="planoRecuperacaoJudicial.credorFornecedorParceiro"></textarea>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label class="form-label">Observações</label>
                        <textarea class="form-control" rows="3" [(ngModel)]="planoRecuperacaoJudicial.observacoes"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="pagina == 2">
        <div class="col-12">
            <table class="table product-discounts-edit espacamento-tabela-dividas">
                <thead>
                    <tr>
                        <th>N. Parcela</th>                        
                        <th width="100px">Vencimento Previsto</th>     
                        <th class="text-right">R$ Valor Parcela</th>                   
                    </tr>
                </thead>
                <tbody style="font-size: 8pt">
                    <tr *ngFor="let parcela of parcelas; let i = index">
                        <td>{{parcela.numero}}</td>
                        <td>
                            <p-calendar appendTo="body" baseZIndex = 1050 [style]="{'width':'120px'}" [(ngModel)]="parcela.dataPrevistaPagamento" dateFormat="dd/mm/yy"
                            slotChar="dd/mm/yyyy" [showIcon]="true" inputId="icon"></p-calendar>
                        </td>
                        <td class="text-right">
                            {{ parcela.valorParcela | currency: 'BRL' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="dismiss()">Fechar</button>
    <button type="button" class="btn btn-success" (click)="gerarParcelas()" *ngIf="pagina == 1"><i class="fas fa-angle-right"></i> Continuar</button>
    <button type="button" class="btn btn-danger" (click)="limparParcelas()" *ngIf="pagina == 2"><i class="fas fa-angle-left"></i> Voltar</button>
</div>